module.exports = __webpack_public_path__ + "img/slide_3_comp_mob.aaf6cc6e.jpg";